<table mat-table [dataSource]="watches" class="w-100">
    <ng-container matColumnDef="isEnabled">
        <th mat-header-cell class="sortable-header" *matHeaderCellDef (click)="requestSort('isenabled')"><span
                class="header-sort-label">Enabled&nbsp;<mat-icon class="sort-indicator" *ngIf="isSorted('isenabled')">{{
                    sortIcon('isenabled') }}</mat-icon></span></th>
        <td mat-cell *matCellDef="let watch" (click)="$event.stopPropagation()">
            <mat-checkbox [checked]="!!watch.isEnabled" (click)="$event.stopPropagation()"
                (change)="onToggleEnabled(watch, $event.checked)">
            </mat-checkbox>
        </td>
    </ng-container>

    <ng-container matColumnDef="name">
        <th mat-header-cell class="sortable-header" *matHeaderCellDef (click)="requestSort('name')"><span
                class="header-sort-label">Name&nbsp;<mat-icon class="sort-indicator" *ngIf="isSorted('name')">{{
                    sortIcon('name') }}</mat-icon></span></th>
        <td mat-cell *matCellDef="let watch" [class.disabled]="!watch.isEnabled">
            <span *ngIf="!isEditing" [class.invalid]="watch.validated === false">{{ watch.name }}</span>
            <input *ngIf="isEditing" [(ngModel)]="watch.name" (click)="$event.stopPropagation()"
                (ngModelChange)="onWatchChanged(watch)" [class.invalid]="watch.validated === false" class="form-control"
                type="text">
        </td>
    </ng-container>

    <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Description</th>
        <td mat-cell *matCellDef="let watch" [class.disabled]="!watch.isEnabled">
            <span *ngIf="!isEditing">{{ watch.description }}</span>
            <input *ngIf="isEditing" [(ngModel)]="watch.description" (click)="$event.stopPropagation()"
                (ngModelChange)="onWatchChanged(watch)" class="form-control" type="text">
        </td>
    </ng-container>

    <ng-container matColumnDef="notificationFrequency">
        <th mat-header-cell class="sortable-header" *matHeaderCellDef (click)="requestSort('notificationFrequency')">
            <span class="header-sort-label">Schedule&nbsp;<mat-icon class="sort-indicator"
                    *ngIf="isSorted('notificationFrequency')">{{ sortIcon('notificationFrequency') }}</mat-icon></span>
        </th>
        <td mat-cell *matCellDef="let watch" [class.disabled]="!watch.isEnabled">
            <span *ngIf="!isEditing">{{ watch.notificationFrequency }}</span>
            <select *ngIf="isEditing" [(ngModel)]="watch.notificationFrequency" (click)="$event.stopPropagation()"
                (ngModelChange)="onWatchChanged(watch)" class="form-control">
                <option value="Daily">Daily</option>
                <option value="Weekly">Weekly</option>
            </select>
        </td>
    </ng-container>

    <ng-container matColumnDef="watchType">
        <th mat-header-cell class="sortable-header" *matHeaderCellDef (click)="requestSort('WatchType')"><span
                class="header-sort-label">Type&nbsp;<mat-icon class="sort-indicator" *ngIf="isSorted('WatchType')">{{
                    sortIcon('WatchType') }}</mat-icon></span></th>
        <td mat-cell *matCellDef="let watch" [class.disabled]="!watch.isEnabled">{{ getWatchTypeLabel(watch) }}</td>
    </ng-container>

    <ng-container matColumnDef="nextNotification">
        <th mat-header-cell class="sortable-header" *matHeaderCellDef (click)="requestSort('nextnotification')"><span
                class="header-sort-label">Next Notification&nbsp;<mat-icon class="sort-indicator"
                    *ngIf="isSorted('nextnotification')">{{ sortIcon('nextnotification') }}</mat-icon></span></th>
        <td mat-cell *matCellDef="let watch">{{ watch.nextNotification | date: 'dd MMM yyyy' }}</td>
    </ng-container>

    <ng-container matColumnDef="lastNotified">
        <th mat-header-cell class="sortable-header" *matHeaderCellDef (click)="requestSort('lastnotified')"><span
                class="header-sort-label">Last Notified&nbsp;<mat-icon class="sort-indicator"
                    *ngIf="isSorted('lastnotified')">{{ sortIcon('lastnotified') }}</mat-icon></span></th>
        <td mat-cell *matCellDef="let watch" [class.disabled]="!watch.isEnabled">{{ watch.lastNotified ?
            (watch.lastNotified | date: 'dd MMM yyyy') : 'never' }}</td>
    </ng-container>

    <ng-container matColumnDef="deleteToggle">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let watch">
            <button *ngIf="isDeleting" mat-icon-button
                (click)="$event.stopPropagation(); onToggleDeleteSelection(watch)">
                <mat-icon>{{ watch.isDeleting ? 'block' : 'radio_button_unchecked' }}</mat-icon>
            </button>
        </td>
    </ng-container>

    <tr mat-header-row
        *matHeaderRowDef="['isEnabled','name','description','notificationFrequency','watchType','nextNotification','lastNotified','deleteToggle']">
    </tr>
    <tr mat-row
        *matRowDef="let watch; columns: ['isEnabled','name','description','notificationFrequency','watchType','nextNotification','lastNotified','deleteToggle']"
        (click)="!isEditing && !isDeleting && selectWatch(watch)">
    </tr>
</table>